module.exports = __webpack_public_path__ + "img/ci.1c450059.svg";